export enum ExchangeEnum {
    TRY = 1,
    USD = 4,
    EURO = 5
}